import { DateTimeUtc, DateTimeUtcService } from '../dateTimesUtc';

interface CreateAppClockService {
    getServerNowUtc: () => string | null;
    context: Window;
}

export interface AppClockService {
    getValue: () => number;
    getAppNowUtc: () => DateTimeUtc;
}

const createAppClockService = ({ getServerNowUtc, context }: CreateAppClockService): AppClockService => {
    const getValue = () => {
        const serverNowUtc = getServerNowUtc();

        if (!context.performance || !serverNowUtc) {
            return Date.now();
        }

        const dateTimeUtc = DateTimeUtcService.parse(serverNowUtc);

        return DateTimeUtcService.getEpoch(dateTimeUtc) + context.performance.now();
    };

    return {
        getValue,
        getAppNowUtc: () => DateTimeUtcService.fromEpoch(getValue()),
    };
};

export default createAppClockService;
